import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { TrialPlanService, trialPlanEventsKeyEnum } from 'src/app/services/trialplan/trialplan.service';
import { BannerConfig } from '../banner/banner.component';

import { getRolesFromToken } from "src/app/shared/helpers/jwt.helper";
import { AuthService } from 'src/app/auth/auth.service';
import { castArray, get } from 'lodash-es';
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';
import { NS_SubscriptionService } from '../../namespaces';
@Component({
  selector: 'app-subscription-event-manager',
  templateUrl: './subscription-event-manager.component.html',
  styleUrls: ['./subscription-event-manager.component.scss']
})
export class SubscriptionEventManagerComponent implements OnInit, OnDestroy {
  @Input() purpose: string;
  @Input() bannerConfig: BannerConfig = {
    theme: 'warning',
    title: ''
  };
  componentDestroy: Subject<any> = new Subject();
  isTrialPlanActive = false;
  isTrialPlanUsed = false;
  trialExpiryMessage = '';
  baseWord: string;
  userRolesFromAPI: any;
  userRole: any;
  showBanner = false;
  intervalID;
  constructor(private trialPlanService: TrialPlanService, private appService: AppService, private authService: AuthService, private subscriptionBusinessService: SubscriptionBusinessService ) { 
    
  }

  ngOnInit(): void {
    this.baseWord = this.appService.getBaseWord();
    let authToken = this.authService.authToken;
    this.userRolesFromAPI = get(this.appService, 'userData.role');
    if(this.componentDestroy.isStopped){
      this.componentDestroy = new Subject();
    }
    
    if(authToken) {
      this.userRole = getRolesFromToken(authToken) ||  castArray(this.userRolesFromAPI);
      this.showBanner = this.subscriptionBusinessService.validate.SubscriptionEventManagerComponent.canShowBanner(this.userRole);
      this.subscriptionBusinessService.eventsSubject.pipe(filter(ev => (ev.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.oldSubscription || ev.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.currentlyActiveCompanySubscription )),
        takeUntil(this.componentDestroy)
      ).subscribe({
        next: ()=>{
          this.showBanner = this.subscriptionBusinessService.validate.SubscriptionEventManagerComponent.canShowBanner(this.userRole);
        }
      });
    }
    this.appService.setSubscriptionBannerVisible(true)
    setTimeout(() => {
      this.appService.setSubscriptionBannerVisible(this.showBanner &&(this.trialExpiryMessage !== ''));
    }, 4000);
    this.subscribeToTrialPlanEventSubject();
    
    
  }

  private subscribeToTrialPlanEventSubject(){

    let subscribe = ()=>{
      this.trialPlanService.trialPlanEventsSubject.pipe(takeUntil(this.componentDestroy)).subscribe((data) => {
        switch (data.eventKey) {
          case trialPlanEventsKeyEnum.isTrialPlanActive:
            this.isTrialPlanActive = data.eventValue;
            break;
          case trialPlanEventsKeyEnum.isTrialPlanUsed:
            this.isTrialPlanUsed = data.eventValue;
            break;
          case trialPlanEventsKeyEnum.trialExpiryMessage:
            this.trialExpiryMessage = data.eventValue;
            this.bannerConfig.theme = get(data, 'bannerConfig.theme', 'warning')
            this.bannerConfig.title = get(data, 'bannerConfig.title');
            this.bannerConfig.description = get(data, 'bannerConfig.description')
            this.bannerConfig.buttonText = get(data, 'bannerConfig.buttonText')
            this.bannerConfig.buttonUrl = get(data, 'bannerConfig.buttonUrl')
            break;
          default:
            break;
        }
      });
    }

    if(!this.trialPlanService.trialPlanEventsSubject.isStopped){
      subscribe();
    } else {
      if(!this.intervalID){
        this.intervalID = setInterval(()=>{
          if(!this.trialPlanService.trialPlanEventsSubject.isStopped){
            clearInterval(this.intervalID);
            subscribe();
          }
        },3000)
      }
    }
  }

  ngOnDestroy(): void {
    this.showBanner = false;
    clearInterval(this.intervalID);
    this.componentDestroy.next();
    this.componentDestroy.complete();
  }

}
